





import {apiV1AdminKnowHowPath} from '@/rails/routes'
import {Component} from 'vue-property-decorator'
import PostForm from '@/components/admin/PostForm.vue'
import PostEdit from '@/components/admin/PostEdit'
import Post, {IPost} from '@/models/Post'
import {BreadCrumb} from '@/pages/page-base'
import KnowHow from "@/models/KnowHow"

@Component({
  components: {
    PostForm
  }
})
export default class KnowHowsEdit extends PostEdit {
  async mounted(): Promise<void> {
    this.targetPath = apiV1AdminKnowHowPath(this.$route.params.id)
    return super.mounted()
  }

  toFrontModel(data: IPost): Post {
    return new KnowHow(data)
  }

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: '転職ノウハウ',
        to: '/admin/know_hows',
        exact: true
      },
      {
        text: '転職ノウハウ編集'
      }
    ]
  }
}
